import { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { toast } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleNotch,
  faCaretUp,
  faCaretDown,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { formatCurrency } from "../utils/currencyUtils";
import Switch from "react-switch";

function MiniTradeForm2() {
  const [trade, setTrade] = useState("BTC");
  const [tradeTab, setTradeTab] = useState("limit");
  const [tradeDetails, setTradeDetails] = useState(null);
  const [copyTraders, setCopyTraders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const leverageoptions = [
    { label: "1x", value: 1 },
    { label: "3x", value: 3 },
    { label: "5x", value: 5 },
    { label: "10x", value: 10 },
    { label: "50x", value: 50 },
  ];

  const typeoptions = [
    { value: "isolated", label: "Isolated" },
    { value: "cross", label: "Cross" },
  ];

  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected
        ? "rgb(30, 33, 36)"
        : isFocused
        ? "rgb(30, 33, 36)"
        : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };

  const [crypto, setCrypto] = useState([]);

  useEffect(() => {
    fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const coinList = data.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );

        const updatedData = coinList.map((coin, index) => {
          const logoUrl = `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`;

          return {
            id: index + 1,
            label: (
              <>
                <img
                  src={logoUrl}
                  alt={coin.symbol}
                  width="20"
                />{" "}
                {coin.symbol}
              </>
            ),
            logo: logoUrl,
            coin_id: coin.id,
            name: coin.name,
            symbol: coin.symbol,
            price: Number(coin.quote.USD.price),
            percentage: Number(
              coin.quote.USD.percent_change_24h.toFixed(2)
            ),
            value: coin.symbol,
          };
        });

        setCrypto(updatedData);
      })
      .catch((err) =>
        console.error("Error loading coin list:", err)
      );
  }, []);

  useEffect(() => {
    const found =
      crypto.find((opt) => opt.value === trade) || null;

    setTradeDetails(found);

    if (found) {
      handlePriceChange(Number(found.price).toFixed(4));
      handlePriceChange1(Number(found.price).toFixed(4));
    }
  }, [crypto, trade]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}controller/fetch.controller.php`,
      {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fetchCopytrade: true,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setCopyTraders(
            data.copytrade.map((trader) => ({
              value: trader.trade_id,
              label: (
                <div className="d-flex align-items-center">
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "100%",
                      marginRight: "8px",
                      width: "25px",
                      height: "25px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={`/uploads/${trader.trader_photo}`}
                      alt={trader.trader_name}
                      width="100%"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  {trader.trader_name}
                </div>
              ),
              trader_name: trader.trader_name,
              username: trader.username,
              trade_id: trader.trade_id,
            }))
          );
        }
      })
      .catch((err) => {
        console.log(err);
        console.error("Error fetching copy traders!");
      });
  }, []);

  const [leverage, setLeverage] = useState(10);
  const [pattern, setPattern] = useState("isolated");
  const [price, setPrice] = useState(0);
  const [currentPrice, setCurrentPrice] = useState(0);
  const [date, setDate] = useState("");
  const [trader, setTrader] = useState("");
  const [order, setOrder] = useState(0);
  const [tp, setTP] = useState(0);
  const [sl, setSL] = useState(0);
  const [status, setStatus] = useState("open");
  const [checked, setChecked] = useState(true);
  const [pnlType, setPnlType] = useState("Profit");
  const [tradepnl, setTradepnl] = useState("");
  const [pnlManuallyEdited, setPnlManuallyEdited] =
    useState(false);

  const isDisabled = !(
    order > 0 &&
    price > 0 &&
    pattern &&
    leverage &&
    trader
  );

  const isDisabled1 = !(
    order > 0 &&
    pattern &&
    leverage &&
    trader
  );

  const isDisabled2 = !(
    order > 0 &&
    price > 0 &&
    pattern &&
    leverage &&
    tp &&
    sl &&
    trader
  );

  const pnlList = [
    { value: "Profit", label: "Profit" },
    { value: "Loss", label: "Loss" },
  ];

  const statusoptions = [
    { value: "position", label: "Position" },
    { value: "closed", label: "Closed" },
    { value: "open", label: "Open" },
  ];

  function handleOrderChange(val) {
    const n = Number(val);
    const nextOrder = Number.isFinite(n) ? n : 0;

    if (order !== nextOrder) {
      setOrder(nextOrder);
      setPnlManuallyEdited(false);
    }
  }

  function handlePriceChange(val) {
    const n = Number(val);
    const nextPrice = Number.isFinite(n) ? n : 0;

    if (price !== nextPrice) {
      setPrice(nextPrice);
      setPnlManuallyEdited(false);
    }
  }

  function handlePriceChange1(val) {
    const n = Number(val);
    const nextPrice = Number.isFinite(n) ? n : 0;

    if (currentPrice !== nextPrice) {
      setCurrentPrice(nextPrice);
      setPnlManuallyEdited(false);
    }
  }

  const orderValue = useMemo(() => {
    const margin = Number(order) || 0;
    const lev = Math.max(Number(leverage) || 1, 1);

    if (margin <= 0) return 0;

    return Number((margin * lev).toFixed(2));
  }, [order, leverage]);

  const qty = useMemo(() => {
    const positionValue = Number(orderValue) || 0;
    const entryPrice = Number(price) || 0;

    if (positionValue <= 0 || entryPrice <= 0) {
      return 0;
    }

    return Number(
      (positionValue / entryPrice).toFixed(6)
    );
  }, [orderValue, price]);

  function calculatePnl(direction) {
    const entryPrice = Number(price) || 0;
    const filledPrice = Number(currentPrice) || 0;
    const positionValue = Number(orderValue) || 0;

    if (
      entryPrice <= 0 ||
      filledPrice <= 0 ||
      positionValue <= 0
    ) {
      return 0;
    }

    const positionSize = positionValue / entryPrice;
    let pnl = 0;

    if (String(direction).toLowerCase() === "long") {
      pnl =
        (filledPrice - entryPrice) * positionSize;
    } else {
      pnl =
        (entryPrice - filledPrice) * positionSize;
    }

    return Number(pnl.toFixed(2));
  }

  const calculatedPnl = useMemo(() => {
    return calculatePnl("Long");
  }, [price, currentPrice, orderValue]);

  useEffect(() => {
    if (
      checked &&
      !pnlManuallyEdited &&
      Number(price) > 0 &&
      Number(currentPrice) > 0 &&
      Number(order) > 0
    ) {
      const pnl = calculatePnl("Long");

      setTradepnl(Math.abs(pnl));
      setPnlType(pnl >= 0 ? "Profit" : "Loss");
    }
  }, [
    checked,
    pnlManuallyEdited,
    price,
    currentPrice,
    order,
  ]);

  function handlePnlSwitch(value) {
    setChecked(value);

    if (value) {
      setPnlManuallyEdited(false);

      const pnl = calculatePnl("Long");

      if (
        Number(price) > 0 &&
        Number(currentPrice) > 0 &&
        Number(order) > 0
      ) {
        setTradepnl(Math.abs(pnl));
        setPnlType(pnl >= 0 ? "Profit" : "Loss");
      }
    }
  }

  function getPnlForSubmit(direction) {
    const calculated = calculatePnl(direction);

    if (!checked) {
      return {
        pnl: Math.abs(calculated),
        pnlType: calculated >= 0 ? "Profit" : "Loss",
      };
    }

    if (pnlManuallyEdited && tradepnl !== "") {
      const manualPnl = Number(tradepnl) || 0;

      return {
        pnl: Math.abs(manualPnl),
        pnlType,
      };
    }

    return {
      pnl: Math.abs(calculated),
      pnlType:
        calculated >= 0 ? "Profit" : "Loss",
    };
  }

  function handleLimit(direction) {
    if (direction === "Short") {
      setLoading(true);
    } else {
      setLoading2(true);
    }

    const pnlData = getPnlForSubmit(direction);

    fetch(
      `${process.env.REACT_APP_API_URL}controller/manage.controller.php`,
      {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          btn_copylimit: true,
          price: price,
          orderval: orderValue,
          leverageInput: leverage,
          futuretypeInput: pattern,
          type: direction,
          coin_id: tradeDetails?.coin_id,
          pnlType: pnlData.pnlType,
          pnl: pnlData.pnl,
          status: status,
          date: date,
          currentprice: currentPrice,
          trader: trader,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        console.log(data);

        if (data.status === "success") {
          toast.success(data.result);

          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          toast.error(data.message);
        }

        setLoading(false);
        setLoading2(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setLoading2(false);
      });
  }

  function handleMarket(direction) {
    if (direction === "Short") {
      setLoading(true);
    } else {
      setLoading2(true);
    }

    const pnlData = getPnlForSubmit(direction);

    fetch(
      `${process.env.REACT_APP_API_URL}controller/manage.controller.php`,
      {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          btn_copymarket: true,
          price: price,
          orderval: orderValue,
          leverageInput: leverage,
          futuretypeInput: pattern,
          type: direction,
          coin_id: tradeDetails?.coin_id,
          pnlType: pnlData.pnlType,
          pnl: pnlData.pnl,
          status: status,
          date: date,
          currentprice: currentPrice,
          trader: trader,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.result);

          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          toast.error(data.message);
        }

        setLoading(false);
        setLoading2(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setLoading2(false);
      });
  }

  function handleTPSL(direction) {
    if (direction === "Short") {
      setLoading(true);
    } else {
      setLoading2(true);
    }

    const pnlData = getPnlForSubmit(direction);

    fetch(
      `${process.env.REACT_APP_API_URL}controller/manage.controller.php`,
      {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          btn_copytpsl: true,
          price: tradeDetails?.price,
          orderval: orderValue,
          leverageInput: leverage,
          futuretypeInput: pattern,
          type: direction,
          coin_id: tradeDetails?.coin_id,
          tp: tp,
          sl: sl,
          pnlType: pnlData.pnlType,
          pnl: pnlData.pnl,
          status: status,
          date: date,
          currentprice: currentPrice,
          trader: trader,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          toast.success(data.result);

          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          toast.error(data.message);
        }

        setLoading(false);
        setLoading2(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        setLoading2(false);
      });
  }

  const [coinListModal, setCoinListModal] =
    useState(false);
  const [coinListSearch, setCoinListSearch] =
    useState("");

  function filterCoinList(search) {
    setCoinListSearch(search);
  }

  const filteredCoinList = useMemo(() => {
    const q = coinListSearch.trim().toLowerCase();

    if (!q) {
      return crypto;
    }

    return crypto.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.symbol.toLowerCase().includes(q)
    );
  }, [coinListSearch, crypto]);

  if (!tradeDetails) {
    return (
      <div
        style={{
          textAlign: "center",
          marginTop: "20%",
          marginBottom: "20%",
        }}
      >
        <FontAwesomeIcon
          icon={faCircleNotch}
          style={{
            fontSize: "30px",
            color: "#ff6b35",
            opacity: "0.5",
          }}
          spin
        />
      </div>
    );
  }

  return (
    <div
      className="mt-2 futurecard position-relative"
      style={{ height: "auto" }}
    >
      <div className="mb-2">
        {tradeDetails && (
          <div
            className="d-flex align-items-center"
            onClick={() =>
              setCoinListModal(!coinListModal)
            }
            style={{ cursor: "pointer" }}
          >
            <img
              src={tradeDetails.logo}
              alt={tradeDetails.symbol}
              width="30"
            />
            <div className="ms-2">
              <p
                className="mb-0 fw-bold"
                style={{ lineHeight: "120%" }}
              >
                {tradeDetails.symbol}USDT{" "}
                <FontAwesomeIcon
                  icon={
                    coinListModal
                      ? faCaretUp
                      : faCaretDown
                  }
                  className="ms-2"
                  style={{ fontSize: "14px" }}
                />
              </p>
              <p
                style={{ fontSize: "14px" }}
                className={`mb-0 ${
                  tradeDetails.percentage > 0
                    ? "text-success"
                    : "text-danger"
                } fw-semibold lh-1`}
              >
                {tradeDetails.percentage}%
              </p>
            </div>
          </div>
        )}

        <div
          className={`coinList wide position-absolute p-3 rounded-3 d-flex flex-column ${
            coinListModal ? "active" : ""
          }`}
          style={{
            backgroundColor: "#101113ff",
            zIndex: "10",
          }}
        >
          <div className="form-control justify-content-between py-1 pe-1">
            <input
              type="search"
              placeholder="Search Coin"
              className="inputNone w-100"
              value={coinListSearch}
              onChange={(e) =>
                filterCoinList(e.target.value)
              }
            />
          </div>

          <div className="mt-2 coinListAll">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <div style={{ width: "60%" }}>
                <p
                  className="mb-0"
                  style={{ fontSize: "14px" }}
                >
                  PAIR
                </p>
              </div>

              <div style={{ width: "40%" }}>
                <p
                  className="mb-0 text-end"
                  style={{ fontSize: "14px" }}
                >
                  PRICE
                </p>
              </div>

              <div style={{ width: "40%" }}>
                <p
                  className="mb-0 text-end"
                  style={{ fontSize: "14px" }}
                >
                  CHANGE
                </p>
              </div>
            </div>

            {filteredCoinList.length > 0 &&
              filteredCoinList.map((coin, index) => {
                if (coin.symbol !== "USDT") {
                  return (
                    <div
                      onClick={() => {
                        setTrade(coin.symbol);
                        setCoinListModal(false);
                      }}
                      key={index}
                      className="d-flex align-items-center justify-content-between mb-2"
                      style={{ cursor: "pointer" }}
                    >
                      <div style={{ width: "60%" }}>
                        <div className="d-flex align-items-center">
                          <img
                            src={coin.logo}
                            alt={coin.symbol}
                            width="20"
                          />

                          <p
                            className="mb-0 ms-1"
                            style={{
                              fontWeight: "900",
                              fontSize: "14px",
                            }}
                          >
                            {coin.symbol}
                          </p>

                          <p
                            className="mb-0"
                            style={{ fontSize: "11px" }}
                          >
                            /USDT
                          </p>
                        </div>
                      </div>

                      <div style={{ width: "40%" }}>
                        <div className="text-end">
                          <p
                            className="mb-0"
                            style={{
                              fontSize: "14px",
                              fontWeight: "900",
                            }}
                          >
                            {Number(coin.price).toFixed(7)}
                          </p>

                          <p
                            className="mb-0"
                            style={{ fontSize: "12px" }}
                          >
                            = {formatCurrency(coin.price)} USD
                          </p>
                        </div>
                      </div>

                      <div style={{ width: "40%" }}>
                        <p className="text-end mb-0">
                          <span
                            className={`d-inline-block py-1 px-2 ${
                              coin.percentage > 0
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                            style={{
                              fontSize: "14px",
                              fontWeight: "900",
                              minWidth: "65px",
                            }}
                          >
                            {coin.percentage.toFixed(2)}%
                          </span>
                        </p>
                      </div>
                    </div>
                  );
                }

                return null;
              })}

            {filteredCoinList.length === 0 && (
              <p className="mb-0 text-center">
                No item found
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-between">
        <Select
          options={typeoptions}
          value={typeoptions.find(
            (opt) => opt.value === pattern
          )}
          onChange={(e) => setPattern(e.value)}
          styles={darkThemeStyles}
          className="w-49"
        />

        <Select
          options={leverageoptions}
          value={leverageoptions.find(
            (opt) => opt.value === leverage
          )}
          onChange={(e) => setLeverage(e.value)}
          styles={darkThemeStyles}
          className="w-49"
        />
      </div>

      <label
        className="fw-semibold mb-1 mt-2"
        style={{ fontSize: "14px" }}
      >
        Copy Experts
      </label>

      <Select
        options={copyTraders}
        placeholder="Copy Experts"
        value={copyTraders.find(
          (opt) => opt.value === trader
        )}
        onChange={(opt) =>
          setTrader(opt?.value || "")
        }
        isSearchable
        styles={darkThemeStyles}
        className="w-100"
      />

      <div className="mytab justify-content-between mt-3">
        <div
          className={`mytab-item1 buy ${
            tradeTab === "limit" ? "active" : ""
          }`}
          style={{ width: "33%" }}
          onClick={() => setTradeTab("limit")}
        >
          LIMIT
        </div>

        <div
          className={`mytab-item1 buy ${
            tradeTab === "market" ? "active" : ""
          }`}
          style={{ width: "33%" }}
          onClick={() => setTradeTab("market")}
        >
          MARKET
        </div>

        <div
          className={`mytab-item1 buy ${
            tradeTab === "tpsl" ? "active" : ""
          }`}
          style={{ width: "33%" }}
          onClick={() => setTradeTab("tpsl")}
        >
          TP/SL
        </div>
      </div>

      {tradeTab === "limit" && (
        <div className="mt-md-2">
          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Entry Price (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder={
                tradeDetails?.price
                  ? formatCurrency(
                      tradeDetails.price -
                        (0.74 / 100) *
                          tradeDetails.price
                    )
                  : "0.00"
              }
              className="inputNone"
              value={price === 0 ? "" : price}
              onChange={(e) =>
                handlePriceChange(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Filled Price (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder={
                tradeDetails?.price
                  ? formatCurrency(
                      tradeDetails.price -
                        (0.74 / 100) *
                          tradeDetails.price
                    )
                  : "0.00"
              }
              className="inputNone"
              value={
                currentPrice === 0
                  ? ""
                  : currentPrice
              }
              onChange={(e) =>
                handlePriceChange1(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Margin (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder="0.00"
              className="inputNone"
              value={order === 0 ? "" : order}
              onChange={(e) =>
                handleOrderChange(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <div className="mycard mt-md-2 py-1 px-3 rounded-2">
            <div className="d-flex align-items-center justify-content-between">
              <p
                className="mb-0 text-white"
                style={{ fontSize: "14px" }}
              >
                Qty
              </p>

              <p
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                <span className="text-success">
                  {qty}
                </span>{" "}
                /{" "}
                <span className="text-danger">
                  {qty}
                </span>{" "}
                {trade}
              </p>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <p
                className="mb-0 text-white"
                style={{ fontSize: "14px" }}
              >
                Order Value
              </p>

              <p
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                <span className="text-success">
                  {orderValue}
                </span>{" "}
                /{" "}
                <span className="text-danger">
                  {orderValue}
                </span>{" "}
                USDT
              </p>
            </div>
          </div>

          <label
            className="fw-semibold mt-2"
            style={{ fontSize: "14px" }}
          >
            Pnl:
          </label>

          <div className="d-flex align-items-center justify-content-between form-control py-2">
            <label
              className="fw-semibold mb-0"
              style={{ fontSize: "14px" }}
            >
              Add profits or loss to this trade
            </label>

            <Switch
              onChange={handlePnlSwitch}
              checked={checked}
              offColor="#404448"
              onColor="#404448"
              offHandleColor="#8c95a0"
              onHandleColor="#ff6b35"
              uncheckedIcon={false}
              checkedIcon={false}
              height={23}
              width={40}
              handleDiameter={18}
            />
          </div>

          {checked && (
            <>
              <label
                className="fw-semibold mt-2"
                style={{ fontSize: "14px" }}
              >
                {pnlType} amount (USD):
              </label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input
                  type="number"
                  step="0.01"
                  placeholder={`How much ${pnlType} do you want to add?`}
                  className="inputNone"
                  value={tradepnl}
                  onChange={(e) => {
                    setPnlManuallyEdited(true);
                    setTradepnl(e.target.value);
                  }}
                />

                <Select
                  options={pnlList}
                  value={pnlList.find(
                    (opt) => opt.value === pnlType
                  )}
                  onChange={(e) => {
                    setPnlManuallyEdited(true);
                    setPnlType(e.value);
                  }}
                  styles={darkThemeStyles}
                  className="w-full"
                />
              </div>

              {!pnlManuallyEdited &&
                Number(price) > 0 &&
                Number(currentPrice) > 0 &&
                Number(order) > 0 && (
                  <div
                    className="mt-1"
                    style={{
                      fontSize: "12px",
                      opacity: 0.65,
                    }}
                  >
                    Automatic PnL:{" "}
                    {calculatedPnl >= 0 ? "+" : ""}
                    {formatCurrency(
                      calculatedPnl
                    )}{" "}
                    USD
                  </div>
                )}
            </>
          )}

          <label
            className="fw-semibold mb-1 mt-2"
            style={{ fontSize: "14px" }}
          >
            Time Created:
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="datetime-local"
              className="inputNone"
              value={date}
              onChange={(e) =>
                setDate(e.target.value)
              }
            />
          </div>

          <label
            className="fw-semibold mb-1 mt-2"
            style={{ fontSize: "14px" }}
          >
            Select Status:
          </label>

          <Select
            options={statusoptions}
            value={statusoptions.find(
              (opt) => opt.value === status
            )}
            onChange={(e) => setStatus(e.value)}
            styles={darkThemeStyles}
            className="w-full w-100"
          />

          <div
            className={`myBtn bg-success w-100 text-center mt-md-4 mt-2 ${
              isDisabled ? "disabled" : ""
            }`}
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            onClick={
              !isDisabled
                ? () => handleLimit("Long")
                : undefined
            }
          >
            {loading2 ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                style={{
                  fontSize: "20px",
                  color: "white",
                  opacity: "0.5",
                }}
                spin
              />
            ) : (
              "Long"
            )}
          </div>

          <div
            className={`myBtn bg-danger w-100 text-center mt-2 ${
              isDisabled ? "disabled" : ""
            }`}
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            onClick={
              !isDisabled
                ? () => handleLimit("Short")
                : undefined
            }
          >
            {loading ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                style={{
                  fontSize: "20px",
                  color: "white",
                  opacity: "0.5",
                }}
                spin
              />
            ) : (
              "Short"
            )}
          </div>
        </div>
      )}

      {tradeTab === "market" && (
        <div className="mt-md-2">
          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Entry Price (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder={
                tradeDetails?.price
                  ? formatCurrency(
                      tradeDetails.price -
                        (0.74 / 100) *
                          tradeDetails.price
                    )
                  : "0.00"
              }
              className="inputNone"
              value={price === 0 ? "" : price}
              onChange={(e) =>
                handlePriceChange(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>
          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Filled Price (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder={
                tradeDetails?.price
                  ? formatCurrency(
                      tradeDetails.price -
                        (0.74 / 100) *
                          tradeDetails.price
                    )
                  : "0.00"
              }
              className="inputNone"
              value={
                currentPrice === 0
                  ? ""
                  : currentPrice
              }
              onChange={(e) =>
                handlePriceChange1(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Margin (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder="0.00"
              className="inputNone"
              value={order === 0 ? "" : order}
              onChange={(e) =>
                handleOrderChange(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <div className="mycard mt-md-2 py-1 px-3 rounded-2">
            <div className="d-flex align-items-center justify-content-between">
              <p
                className="mb-0 text-white"
                style={{ fontSize: "14px" }}
              >
                Qty
              </p>

              <p
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                <span className="text-success">
                  {qty}
                </span>{" "}
                /{" "}
                <span className="text-danger">
                  {qty}
                </span>{" "}
                {trade}
              </p>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <p
                className="mb-0 text-white"
                style={{ fontSize: "14px" }}
              >
                Order Value
              </p>

              <p
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                <span className="text-success">
                  {orderValue}
                </span>{" "}
                /{" "}
                <span className="text-danger">
                  {orderValue}
                </span>{" "}
                USDT
              </p>
            </div>
          </div>

          <label
            className="fw-semibold mt-2"
            style={{ fontSize: "14px" }}
          >
            Pnl:
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-2">
            <label
              className="fw-semibold mb-0"
              style={{ fontSize: "14px" }}
            >
              Add profits or loss to this trade
            </label>

            <Switch
              onChange={handlePnlSwitch}
              checked={checked}
              offColor="#404448"
              onColor="#404448"
              offHandleColor="#8c95a0"
              onHandleColor="#ff6b35"
              uncheckedIcon={false}
              checkedIcon={false}
              height={23}
              width={40}
              handleDiameter={18}
            />
          </div>

          {checked && (
            <>
              <label
                className="fw-semibold mt-2"
                style={{ fontSize: "14px" }}
              >
                {pnlType} amount (USD):
              </label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input
                  type="number"
                  step="0.01"
                  placeholder={`How much ${pnlType} do you want to add?`}
                  className="inputNone"
                  value={tradepnl}
                  onChange={(e) => {
                    setPnlManuallyEdited(true);
                    setTradepnl(e.target.value);
                  }}
                />

                <Select
                  options={pnlList}
                  value={pnlList.find(
                    (opt) => opt.value === pnlType
                  )}
                  onChange={(e) => {
                    setPnlManuallyEdited(true);
                    setPnlType(e.value);
                  }}
                  styles={darkThemeStyles}
                  className="w-full"
                />
              </div>

              {!pnlManuallyEdited &&
                Number(currentPrice) > 0 &&
                Number(order) > 0 && (
                  <div
                    className="mt-1"
                    style={{
                      fontSize: "12px",
                      opacity: 0.65,
                    }}
                  >
                    Automatic PnL:{" "}
                    {calculatedPnl >= 0 ? "+" : ""}
                    {formatCurrency(
                      calculatedPnl
                    )}{" "}
                    USD
                  </div>
                )}
            </>
          )}

          <label
            className="fw-semibold mb-1 mt-2"
            style={{ fontSize: "14px" }}
          >
            Time Created:
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="datetime-local"
              className="inputNone"
              value={date}
              onChange={(e) =>
                setDate(e.target.value)
              }
            />
          </div>

          <label
            className="fw-semibold mb-1"
            style={{ fontSize: "14px" }}
          >
            Select Status:
          </label>

          <Select
            options={statusoptions}
            value={statusoptions.find(
              (opt) => opt.value === status
            )}
            onChange={(e) => setStatus(e.value)}
            styles={darkThemeStyles}
            className="w-full w-100"
          />

          <div
            className={`myBtn bg-success w-100 text-center mt-md-4 mt-2 ${
              isDisabled1 ? "disabled" : ""
            }`}
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            onClick={
              !isDisabled1
                ? () => handleMarket("Long")
                : undefined
            }
          >
            {loading2 ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                style={{
                  fontSize: "20px",
                  color: "white",
                  opacity: "0.5",
                }}
                spin
              />
            ) : (
              "Long"
            )}
          </div>

          <div
            className={`myBtn bg-danger w-100 text-center mt-2 ${
              isDisabled1 ? "disabled" : ""
            }`}
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            onClick={
              !isDisabled1
                ? () => handleMarket("Short")
                : undefined
            }
          >
            {loading ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                style={{
                  fontSize: "20px",
                  color: "white",
                  opacity: "0.5",
                }}
                spin
              />
            ) : (
              "Short"
            )}
          </div>
        </div>
      )}

      {tradeTab === "tpsl" && (
        <div className="mt-md-2">
          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Entry Price (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder={
                tradeDetails?.price
                  ? formatCurrency(
                      tradeDetails.price -
                        (0.74 / 100) *
                          tradeDetails.price
                    )
                  : "0.00"
              }
              className="inputNone"
              value={price === 0 ? "" : price}
              onChange={(e) =>
                handlePriceChange(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Filled Price (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder={
                tradeDetails?.price
                  ? formatCurrency(
                      tradeDetails.price -
                        (0.74 / 100) *
                          tradeDetails.price
                    )
                  : "0.00"
              }
              className="inputNone"
              value={
                currentPrice === 0
                  ? ""
                  : currentPrice
              }
              onChange={(e) =>
                handlePriceChange1(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <label
            className="fw-semibold mb-1 mt-md-2 mt-1"
            style={{ fontSize: "14px" }}
          >
            Margin (USDT)
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="number"
              placeholder="0.00"
              className="inputNone"
              value={order === 0 ? "" : order}
              onChange={(e) =>
                handleOrderChange(e.target.value)
              }
            />

            <div
              className="fw-bold text-white"
              style={{
                backgroundColor: "rgb(30, 33, 36)",
                borderRadius: "4px",
                padding: "6px",
                fontSize: "14px",
              }}
            >
              USDT
            </div>
          </div>

          <div className="mycard mt-md-2 py-1 px-3 rounded-2">
            <div className="d-flex align-items-center justify-content-between">
              <p
                className="mb-0 text-white"
                style={{ fontSize: "14px" }}
              >
                Qty
              </p>

              <p
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                <span className="text-success">
                  {qty}
                </span>{" "}
                /{" "}
                <span className="text-danger">
                  {qty}
                </span>{" "}
                {trade}
              </p>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <p
                className="mb-0 text-white"
                style={{ fontSize: "14px" }}
              >
                Order Value
              </p>

              <p
                className="mb-0"
                style={{ fontSize: "14px" }}
              >
                <span className="text-success">
                  {orderValue}
                </span>{" "}
                /{" "}
                <span className="text-danger">
                  {orderValue}
                </span>{" "}
                USDT
              </p>
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between mt-2">
            <div style={{ width: "49%" }}>
              <label
                className="fw-semibold mb-1 mt-md-2 mt-1"
                style={{ fontSize: "14px" }}
              >
                Stop Loss:
              </label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input
                  type="text"
                  placeholder={
                    tradeDetails?.price
                      ? formatCurrency(
                          tradeDetails.price -
                            (0.74 / 100) *
                              tradeDetails.price
                        )
                      : "0.00"
                  }
                  className="inputNone"
                  value={sl}
                  onChange={(e) =>
                    setSL(e.target.value)
                  }
                />

                <div
                  className="fw-bold text-white"
                  style={{
                    backgroundColor: "rgb(30, 33, 36)",
                    borderRadius: "4px",
                    padding: "6px",
                    fontSize: "14px",
                  }}
                >
                  {trade}
                </div>
              </div>
            </div>

            <div style={{ width: "49%" }}>
              <label
                className="fw-semibold mb-1 mt-md-2 mt-1"
                style={{ fontSize: "14px" }}
              >
                Take Profit:
              </label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input
                  type="text"
                  placeholder={
                    tradeDetails?.price
                      ? formatCurrency(
                          tradeDetails.price +
                            (0.74 / 100) *
                              tradeDetails.price
                        )
                      : "0.00"
                  }
                  className="inputNone"
                  value={tp}
                  onChange={(e) =>
                    setTP(e.target.value)
                  }
                />

                <div
                  className="fw-bold text-white"
                  style={{
                    backgroundColor: "rgb(30, 33, 36)",
                    borderRadius: "4px",
                    padding: "6px",
                    fontSize: "14px",
                  }}
                >
                  {trade}
                </div>
              </div>
            </div>
          </div>

          <label
            className="fw-semibold mt-2"
            style={{ fontSize: "14px" }}
          >
            Pnl:
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-2">
            <label
              className="fw-semibold mb-0"
              style={{ fontSize: "14px" }}
            >
              Add profits or loss to this trade
            </label>

            <Switch
              onChange={handlePnlSwitch}
              checked={checked}
              offColor="#404448"
              onColor="#404448"
              offHandleColor="#8c95a0"
              onHandleColor="#ff6b35"
              uncheckedIcon={false}
              checkedIcon={false}
              height={23}
              width={40}
              handleDiameter={18}
            />
          </div>

          {checked && (
            <>
              <label
                className="fw-semibold mt-2"
                style={{ fontSize: "14px" }}
              >
                {pnlType} amount (USD):
              </label>

              <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
                <input
                  type="number"
                  step="0.01"
                  placeholder={`How much ${pnlType} do you want to add?`}
                  className="inputNone"
                  value={tradepnl}
                  onChange={(e) => {
                    setPnlManuallyEdited(true);
                    setTradepnl(e.target.value);
                  }}
                />

                <Select
                  options={pnlList}
                  value={pnlList.find(
                    (opt) => opt.value === pnlType
                  )}
                  onChange={(e) => {
                    setPnlManuallyEdited(true);
                    setPnlType(e.value);
                  }}
                  styles={darkThemeStyles}
                  className="w-full"
                />
              </div>

              {!pnlManuallyEdited &&
                Number(price) > 0 &&
                Number(currentPrice) > 0 &&
                Number(order) > 0 && (
                  <div
                    className="mt-1"
                    style={{
                      fontSize: "12px",
                      opacity: 0.65,
                    }}
                  >
                    Automatic PnL:{" "}
                    {calculatedPnl >= 0 ? "+" : ""}
                    {formatCurrency(
                      calculatedPnl
                    )}{" "}
                    USD
                  </div>
                )}
            </>
          )}

          <label
            className="fw-semibold mb-1 mt-2"
            style={{ fontSize: "14px" }}
          >
            Time Created:
          </label>

          <div className="d-flex align-items-between form-control justify-content-between py-1 pe-1">
            <input
              type="datetime-local"
              className="inputNone"
              value={date}
              onChange={(e) =>
                setDate(e.target.value)
              }
            />
          </div>

          <label
            className="fw-semibold mb-1"
            style={{ fontSize: "14px" }}
          >
            Select Status:
          </label>

          <Select
            options={statusoptions}
            value={statusoptions.find(
              (opt) => opt.value === status
            )}
            onChange={(e) => setStatus(e.value)}
            styles={darkThemeStyles}
            className="w-full w-100"
          />

          <div
            className={`myBtn bg-success w-100 text-center mt-md-4 mt-2 ${
              isDisabled2 ? "disabled" : ""
            }`}
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            onClick={
              !isDisabled2
                ? () => handleTPSL("Long")
                : undefined
            }
          >
            {loading2 ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                style={{
                  fontSize: "20px",
                  color: "white",
                  opacity: "0.5",
                }}
                spin
              />
            ) : (
              "Long"
            )}
          </div>

          <div
            className={`myBtn bg-danger w-100 text-center mt-2 ${
              isDisabled2 ? "disabled" : ""
            }`}
            style={{
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            onClick={
              !isDisabled2
                ? () => handleTPSL("Short")
                : undefined
            }
          >
            {loading ? (
              <FontAwesomeIcon
                icon={faCircleNotch}
                style={{
                  fontSize: "20px",
                  color: "white",
                  opacity: "0.5",
                }}
                spin
              />
            ) : (
              "Short"
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default MiniTradeForm2;